let questionsd = document.querySelectorAll(".questionsd");
questionsd.forEach(questionsd => {
  questionsd.addEventListener("click", event => {
    // const active = document.querySelector(".questionsd.active");
    // if (active && active !== questionsd) {
    //   questionsd.classList.toggle("active");
    //   questionsd.nextElementSibling.style.maxHeight = 0;
    // }
    // questionsd.classList.toggle("active");
    // const answersd = questionsd.nextElementSibling;
    // if (questionsd.classList.contains("active")) {
    //   answersd.style.maxHeight = answersd.scrollHeight + "px";
    // } else {
    //   //answersd.style.maxHeight = 0;
    // }
    questionsd.classList.toggle("active");
    questionsd.nextElementSibling.style.maxHeight = questionsd.nextElementSibling.scrollHeight + "px";
    
    if (!questionsd.classList.contains("active")) {
      questionsd.nextElementSibling.style.maxHeight = 0;
    } else {
      
    }
    
  })
})